/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsResourceControllerCreateMutationRequest, IntegrationsResourceControllerCreateMutationResponse, IntegrationsResourceControllerCreate400, IntegrationsResourceControllerCreate401, IntegrationsResourceControllerCreate403 } from "../../models/integrationsController/IntegrationsResourceControllerCreate";

function getIntegrationsResourceControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/integrations` as const }  
  return res
}

/**
 * @summary Connect a scope to an external project
 * {@link /api/v1/integrations}
 */
export async function integrationsResourceControllerCreate(data?: IntegrationsResourceControllerCreateMutationRequest, config: Partial<RequestConfig<IntegrationsResourceControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<IntegrationsResourceControllerCreateMutationResponse, ResponseErrorConfig<IntegrationsResourceControllerCreate400 | IntegrationsResourceControllerCreate401 | IntegrationsResourceControllerCreate403>, IntegrationsResourceControllerCreateMutationRequest>({ method : "POST", url : getIntegrationsResourceControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}